export enum DocumentActionType {
  DOWNLOAD = "download",
  OPEN = "open",
}
